export function scrollX(node) {
    if (!node) {
        return 0;
    }
    if (!(node instanceof HTMLElement)) {
        return 0;
    }
    return node.scrollLeft + scrollX(node.parentNode);
}
export function scrollY() {
    if (typeof window !== 'undefined') {
        return typeof window.scrollY === 'number'
            ? window.scrollY
            : window.pageYOffset;
    }
    return 0;
}
//# sourceMappingURL=scroll.js.map